<template>
  <div></div>
</template>
<script>
import { useRoute, useRouter } from "vue-router";
import { requestWechatInfo, requestWechatCode } from "@/api/wechat/wechatAuto";
export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const wechatCode = route.query.code;
    const url = route.query.url;
    if (url) {
      localStorage.setItem("redirect_url", url);
      window.location.replace(requestWechatCode());
    }

    if (wechatCode) {
      const redirectUrl = localStorage.getItem("redirect_url");
      // requestWechatInfo(wechatCode).then(() => {
      // });
      router.replace(redirectUrl)
      console.log(wechatCode, redirectUrl);
    }
    console.log(route.query);
  },
};
</script>